module.exports = __webpack_public_path__ + "static/media/roundedDisabled.51af6e0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/roundedDisabled.svg
// module id = 1049
// module chunks = 49